// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = (callback: (...args: any) => void, wait: number) => {
  let timeout: NodeJS.Timeout | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      callback(...args);
    }, wait);
  };
};
